import { useEffect, useState } from 'react';
import { API, apiRequest } from '../services/api-client';
import { useCommerce } from './commerce';
import { BRAND_NAME } from '../config/brand';
import { configuredPaddle } from './paddle-client';

export function CheckoutPage() {
  const commerce = useCommerce();
  const [transactionId] = useState(() => new URLSearchParams(location.search).get('_ptxn'));
  const [message, setMessage] = useState('Checking your checkout…');
  useEffect(() => {
    let active = true;
    const open = async () => {
      if (!transactionId || !/^txn_[a-z0-9]+$/.test(transactionId)) throw new Error('Return to your account to start checkout.');
      const config = commerce?.config;
      if (!config?.paddleClientToken || !config.paddleEnvironment) throw new Error('Checkout is not configured.');
      const ownership = await apiRequest<{ customerEmail: string | null }>(`${API}/billing/checkout/${transactionId}`);
      // Prevent Paddle's automatic query-string opener from bypassing the ownership check.
      history.replaceState(null, '', '/checkout');
      const paddle = await configuredPaddle(config);
      if (!active) return;
      paddle.Checkout.open({ transactionId, ...(ownership.customerEmail ? { customer: { email: ownership.customerEmail, ...(config.countryCode ? { address: { countryCode: config.countryCode } } : {}) } } : {}), settings: { displayMode: 'overlay', variant: 'one-page', allowLogout: false, successUrl: new URL('/account', location.origin).href } });
      setMessage('Complete payment in the secure checkout. Your paid access starts after server payment confirmation.');
    };
    void open().catch(error => { if (active) setMessage(error instanceof Error ? error.message : 'Unable to open checkout.'); });
    return () => { active = false; };
  }, [commerce?.config, transactionId]);
  return <main className="account-page"><h1>Subscribe to {BRAND_NAME}</h1><p role="status">{message}</p><a href="/account">Return to your account</a></main>;
}
